<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh
                            v-if="inventory_receipt.receipt_id && inventory_receipt.receipt_id > 0"
                            @invoke-method="dbGetInventoryReceipt(true)"
                        ></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="inventory_receipt.receipt_id && inventory_receipt.receipt_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print </v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('inventory_receipts.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in inventory_receipt_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != inventory_receipt.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('inventory_receipts.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_inventory_receipt.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'inventory_receipts' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="inventory_receipt.status" class="ribbon ribbon-top-right" :class="`ribbon-${inventory_receipt.status_class}`">
                            <span class="ribbon-span">{{ inventory_receipt.status }}</span>
                        </div>
                        <v-form ref="formInventoryReceipt">
                            <v-flex xs12>
                                <v-text-field
                                    v-focus="inventory_receipt_dialog"
                                    v-model="inventory_receipt.receipt_id"
                                    :label="$t('lang.receipt_id')"
                                    :counter="showCounter(inventory_receipt.receipt_id, 'inventory_receipts.receipt_id')"
                                    :rules="ifValid('inventory_receipts.receipt_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="inventory_receipt.purchase_order_id"
                                    :label="$t('lang.purchase_order_id')"
                                    :counter="showCounter(inventory_receipt.purchase_order_id, 'inventory_receipts.purchase_order_id')"
                                    :rules="ifValid('inventory_receipts.purchase_order_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="inventory_receipt.part_id"
                                    :label="$t('lang.part_id')"
                                    :items="parts"
                                    item-value="part_id"
                                    item-text="part_id"
                                    :rules="ifValid('inventory_receipts.part_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="inventory_receipt.receipt_date"
                                    :label="$t('lang.receipt_date')"
                                    :rules="ifValid('inventory_receipts.receipt_date')"
                                ></bc-date-picker>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="inventory_receipt.received_quantity"
                                    :label="$t('lang.received_quantity')"
                                    :counter="showCounter(inventory_receipt.received_quantity, 'inventory_receipts.received_quantity')"
                                    :rules="ifValid('inventory_receipts.received_quantity')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="inventory_receipt.received_cost"
                                    :label="$t('lang.received_cost')"
                                    :counter="showCounter(inventory_receipt.received_cost, 'inventory_receipts.received_cost')"
                                    :rules="ifValid('inventory_receipts.received_cost')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="inventory_receipt.vendor_id"
                                    :label="$t('lang.vendor_id')"
                                    :items="vendor_id"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('inventory_receipts.vendor_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="inventory_receipt.received_by"
                                    :label="$t('lang.received_by')"
                                    :counter="showCounter(inventory_receipt.received_by, 'inventory_receipts.received_by')"
                                    :rules="ifValid('inventory_receipts.received_by')"
                                ></v-text-field>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'inventory_receipts' })" flat>{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="saveInventoryReceipts">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_inventory_receipt"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_inventory_receipt')"
                :message="$t('lang.delete_inventory_receipt_confirm')"
                @onConfirm="deleteInventoryReceipts()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_inventory_receipt_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteInventoryReceiptDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            inventory_receipt: {},
            file_name: "",
            dbGetInventoryReceipt: _.debounce(this.getInventoryReceipt, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchInventoryReceipt", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.inventory_receipt) {
                        this.inventory_receipt = this.assignObj2(data.inventory_receipt, this.rules_inventory_receipts);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=inventory_receipt_status&sort_by=2",
                            method: "get",
                            stateProperty: "inventory_receipt_status_options",
                            dataProperty: "options",
                            commit: true,
                        });
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "inventory_receipts", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchInventoryReceipt", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.inventory_receipts) {
                        next((vm) => {
                            vm.inventory_receipt = vm.assignObj2(data.inventory_receipt, vm.rules_inventory_receipts);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=inventory_receipt_status&sort_by=2",
                                method: "get",
                                stateProperty: "inventory_receipt_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "inventory_receipts", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=inventory_receipt_status&sort_by=2",
            method: "get",
            stateProperty: "inventory_receipt_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_inventory_receipts: (state) => state.inventory_receipts.rules_inventory_receipts,
            inventory_receipt_status_options: (state) => state.settings.inventory_receipt_status_options,
            inventory_receipts: (state) => state.inventory_receipts.inventory_receipts,
            selectedInventoryReceipt: (state) => state.inventory_receipts.selectedInventoryReceipt,
            parts: (state) => state.parts.parts,
        }),
    },
    methods: {
        ...mapActions(["fetchInventoryReceipt", "saveInventoryReceipt", "deleteInventoryReceipt", "printInventoryReceipt", "fetchParts"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getInventoryReceipt(pg_refresh = false) {
            this.startLoader();

            this.fetchInventoryReceipt({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.inventory_receipt) {
                    this.inventory_receipt = this.assignObj2(data.inventory_receipt, this.rules_inventory_receipts);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printInventoryReceipt({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.inventory_receipt) {
                    if (this.dev_mode) {
                        this.file_name = data.inventory_receipt.file_name;
                    } else {
                        this.$refs.print.printReport(data.inventory_receipt.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveInventoryReceipts() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formInventoryReceipt")) {
                    let body = this.prepForm(this.inventory_receipt, this.rules_inventory_receipts);

                    this.saveInventoryReceipt({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.inventory_receipt) {
                            this.$router.push({ name: "inventory_receipt", params: { id: data.inventory_receipt.receipt_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { receipt_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveInventoryReceipts({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.inventory_receipt) {
                    this.inventory_receipt = this.assignObj2(data.inventory_receipt, this.rules_inventory_receipts);
                }
            });
        },
        deleteInventoryReceipts() {
            this.deleteInventoryReceipt({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "inventory_receipts" });
                }
                this.toggleModalLoader(false);
            });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchInventoryReceipt({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.inventory_receipt) {
                        this.inventory_receipt = this.assignObj2(data.inventory_receipt, this.rules_inventory_receipts);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            }

            if (this.parts.length == 0 || force == true) await this.fetchParts({ body: { options: 1 } });
        },
    },
    created() {},
};
</script>
